<div class="notifications">
  <div (click)="hide(note)" *ngFor="let note of notes" class=" alert alert-{{note.type}}">
    {{ note.message }}
  </div>
</div>
